import { RefObject } from "react";
import {
  Box,
  FilterProvider,
  PaginationProvider,
  SearchProvider,
  SortProvider,
  MarketingFilesProvider,
} from "dash-ui";
import { GetPropertyByIdQuery } from "gql/generated.graphql";
import MarketingFiles from "./components/MarketingFiles";

interface MarketingFilesSectionProps {
  property: GetPropertyByIdQuery["getPropertyById"];
  containerRef?: RefObject<HTMLDivElement>;
  allowDownloads?: boolean;
  isSeeker?: boolean;
}

const MarketingFilesSection = ({
  property,
  containerRef,
  allowDownloads,
  isSeeker,
}: MarketingFilesSectionProps) => (
  <Box mt={8} mb={2} ref={containerRef}>
    <PaginationProvider perPage={16}>
      <SearchProvider>
        <FilterProvider>
          <SortProvider>
            <MarketingFilesProvider>
              <MarketingFiles 
                property={property} 
                allowDownloads={allowDownloads}
                isSeeker={isSeeker}
              />
            </MarketingFilesProvider>
          </SortProvider>
        </FilterProvider>
      </SearchProvider>
    </PaginationProvider>
  </Box>
);

export default MarketingFilesSection;